module.exports = __webpack_public_path__ + "static/cabina-de-conductor---tablero-de-control-b06362f2b7ae88b384b30e968a8b03ba.jpg";